import './Tos.css';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isStaff, getCurrentUser, updateUser } from '../../api/users_institutions';

function TosBlock({ block }) {
    switch (block.type) {
        case 'h4':
            return <h4>{block.text}</h4>;
        case 'h5':
            return <h5>{block.text}</h5>;
        case 'p':
            return <p>{block.text}</p>;
        case 'ul':
            return (
                <ul>
                    {block.items.map((item, idx) => <li key={idx}>{item}</li>)}
                </ul>
            );
        case 'html':
            return <p dangerouslySetInnerHTML={{ __html: block.html }} />;
        default:
            return null;
    }
}

function Tos({ closeTosPopup }) {
    const { t } = useTranslation();
    const admin = isStaff();
    const [show, setShow] = useState(false);

    // Mount at opacity 0 (per Tos.css), then flip to .show a frame later so the
    // fade/pop-up transition actually animates instead of snapping straight to visible.
    useEffect(() => {
        const frame = requestAnimationFrame(() => setShow(true));
        return () => cancelAnimationFrame(frame);
    }, []);

    const acceptTos = async () => {
        const user = getCurrentUser();
        if (user?.id) {
            try {
                await updateUser(user.id, { tos_accepted: true });
            } catch (error) {
                console.error('Error accepting Terms of Service:', error);
            }
        }
        closeTosPopup();
    };

    const scope = admin ? 'admin' : 'user';
    const intro = t(`tos.${scope}.intro`, { returnObjects: true });
    const content = t(`tos.${scope}.content`, { returnObjects: true });

    return (
        <div id="tos-popup-overlay" className={`tos-overlay${show ? ' show' : ''}`}>
            <div className="tos-modal">
                <div className="tos-header">
                    <div className={`tos-icon${admin ? ' admin' : ''}`}>
                        {admin ? (
                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                            </svg>
                        ) : (
                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                <path d="M7 11V7a5 5 0 0110 0v4"></path>
                            </svg>
                        )}
                    </div>

                    <h2 className="tos-title">{t(`tos.${scope}.title`)}</h2>
                    <p className="tos-subtitle">{t(`tos.${scope}.subtitle`)}</p>
                </div>

                <div className="tos-scroll-box">
                    <p className="tos-intro">
                        {intro.map((line, idx) => (
                            <React.Fragment key={idx}>
                                {line}
                                {idx < intro.length - 1 && <><br /><br /></>}
                            </React.Fragment>
                        ))}
                    </p>

                    {content.map((block, idx) => (
                        <TosBlock key={idx} block={block} />
                    ))}
                </div>

                <div className="tos-actions">
                    <button className={`btn-tos-primary${admin ? ' admin' : ''}`} onClick={acceptTos}>
                        {t('tos.agreeButton')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Tos;
